export default __webpack_public_path__ + "static/IllustrationSmartMirror-7c1a1493af00480ae18957d1be784bec.png";